import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Layout, Package } from 'lucide-react';
export function AdvantageGrid() {
  const advantages = [{
    icon: MapPin,
    title: 'Convenient Maryland Location',
    description: 'Centrally located with easy access from DC, Virginia, and Baltimore. Ample parking and proximity to major hotels.'
  }, {
    icon: Layout,
    title: 'Customizable Floor Plans',
    description: 'Every space adapts to your vision. From theater-style to banquet rounds, we configure the perfect layout for your event.'
  }, {
    icon: Package,
    title: 'All-Inclusive Packages',
    description: 'Catering, décor, entertainment, and coordination—all seamlessly bundled. One venue, zero stress.'
  }];
  return <section className="py-24 px-6 md:px-12 bg-h2o-950" data-id="element-16">
      <div className="max-w-7xl mx-auto" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-19">
            The H2O Advantage
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-20">
            Everything you need for a flawless event, all under one roof.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-21">
          {advantages.map((adv, index) => {
          const Icon = adv.icon;
          return <motion.div key={adv.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="bg-h2o-800/30 border border-slate-700/30 rounded-lg p-8 text-center hover:border-h2o-cyan/20 transition-colors duration-300 flex flex-col items-center" data-id="element-22">
                <div className="w-16 h-16 rounded-full bg-h2o-900 flex items-center justify-center mb-6 border border-slate-700/50" data-id="element-23">
                  <Icon className="w-8 h-8 text-h2o-cyan" data-id="element-24" />
                </div>
                <h3 className="text-xl font-bold text-white mb-4" data-id="element-25">
                  {adv.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-26">
                  {adv.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}